/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Trial_End_Reminder_ContentInputs */

const en_dialog_trial_end_reminder_content = /** @type {(inputs: Dialog_Trial_End_Reminder_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your trial ends on [%s]. Please check your subscription options at least 24 hours in advance if you’d like to cancel.`)
};

const ar_dialog_trial_end_reminder_content = /** @type {(inputs: Dialog_Trial_End_Reminder_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنتهي الفترة التجريبية الخاصة بك في [%s]. يرجى التحقق من خيارات اشتراكك قبل 24 ساعة على الأقل إذا كنت ترغب في الإلغاء.`)
};

const de_dialog_trial_end_reminder_content = /** @type {(inputs: Dialog_Trial_End_Reminder_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr Probeabonnement endet am [%s]. Bitte prüfen Sie Ihre Abonnementoptionen mindestens 24 Stunden im Voraus, wenn Sie kündigen möchten.`)
};

const es_dialog_trial_end_reminder_content = /** @type {(inputs: Dialog_Trial_End_Reminder_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu periodo de prueba finaliza el [%s]. Si deseas cancelar tu suscripción, consulta las opciones de suscripción con al menos 24 horas de antelación.`)
};

const fr_dialog_trial_end_reminder_content = /** @type {(inputs: Dialog_Trial_End_Reminder_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre essai se termine le [%s]. Veuillez modifier vos options d'abonnement au moins 24 heures à l'avance si vous souhaitez annuler votre abonnement.`)
};

const it_dialog_trial_end_reminder_content = /** @type {(inputs: Dialog_Trial_End_Reminder_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua prova termina il [%s]. Controlla le tue opzioni di abbonamento almeno 24 ore prima se desideri annullare.`)
};

const ja_dialog_trial_end_reminder_content = /** @type {(inputs: Dialog_Trial_End_Reminder_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トライアルは[%s]に終了します。キャンセルをご希望の場合は、少なくとも24時間前までにサブスクリプションオプションをご確認ください。`)
};

const ko_dialog_trial_end_reminder_content = /** @type {(inputs: Dialog_Trial_End_Reminder_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료 체험이 [%s]에 끝나요. 취소하려면 최소 24시간 전에 구독 옵션을 확인해 주세요.`)
};

const pt_br_dialog_trial_end_reminder_content = /** @type {(inputs: Dialog_Trial_End_Reminder_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu teste grátis termina em [%s]. Se quiser efetuar o cancelamento, confira suas opções de assinatura com pelo menos 24 horas de antecedência.`)
};

const ru_dialog_trial_end_reminder_content = /** @type {(inputs: Dialog_Trial_End_Reminder_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваша пробная версия заканчивается [%s]. Проверьте параметры подписки не менее чем за 24 часа, если хотите отписаться.`)
};

const th_dialog_trial_end_reminder_content = /** @type {(inputs: Dialog_Trial_End_Reminder_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การทดลองใช้ของคุณจะสิ้นสุดในวันที่ [%s] โปรดตรวจสอบตัวเลือกการสมัครสมาชิกของคุณอย่างน้อย 24 ชั่วโมงล่วงหน้าหากคุณต้องการยกเลิก`)
};

const tr_dialog_trial_end_reminder_content = /** @type {(inputs: Dialog_Trial_End_Reminder_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deneme süren [%s] tarihinde sona erecektir. İptal etmek istersen lütfen abonelik seçeneklerini en az 24 saat önceden kontrol et.`)
};

const zh_cn_dialog_trial_end_reminder_content = /** @type {(inputs: Dialog_Trial_End_Reminder_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费体验将于[%s]结束。如需取消，请至少提前 24 小时查看订阅选项。`)
};

const zh_tw_dialog_trial_end_reminder_content = /** @type {(inputs: Dialog_Trial_End_Reminder_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`試用將於[%s]結束，提前 24 小時取消則不產生續訂費用。`)
};

/**
* | output |
* | --- |
* | "Your trial ends on [%s]. Please check your subscription options at least 24 hours in advance if you’d like to cancel." |
*
* @param {Dialog_Trial_End_Reminder_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_trial_end_reminder_content = /** @type {((inputs?: Dialog_Trial_End_Reminder_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Trial_End_Reminder_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_trial_end_reminder_content(inputs)
	if (locale === "ar") return ar_dialog_trial_end_reminder_content(inputs)
	if (locale === "de") return de_dialog_trial_end_reminder_content(inputs)
	if (locale === "es") return es_dialog_trial_end_reminder_content(inputs)
	if (locale === "fr") return fr_dialog_trial_end_reminder_content(inputs)
	if (locale === "it") return it_dialog_trial_end_reminder_content(inputs)
	if (locale === "ja") return ja_dialog_trial_end_reminder_content(inputs)
	if (locale === "ko") return ko_dialog_trial_end_reminder_content(inputs)
	if (locale === "pt_br") return pt_br_dialog_trial_end_reminder_content(inputs)
	if (locale === "ru") return ru_dialog_trial_end_reminder_content(inputs)
	if (locale === "th") return th_dialog_trial_end_reminder_content(inputs)
	if (locale === "tr") return tr_dialog_trial_end_reminder_content(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_trial_end_reminder_content(inputs)
	return zh_tw_dialog_trial_end_reminder_content(inputs)
});